<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="{{ 'common.strSearch' | translate }}"
          [(ngModel)]="strSearch"
        />
      </nb-form-field>

      <button
        type="submit"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="create()"
        [disabled]="loading"
        [class.btn-pulse]="loading"
      >
        {{ "buttons.create" | translate }}
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="let item of catalogs | filter: strSearch"
        class="content"
      >
        <div class="form-inline">
          <div *ngIf="!item.editing" class="text-body">{{ item.title }}</div>
          <nb-form-field *ngIf="item.editing" fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              shape="semi-round"
              nbTooltip="Hủy"
              (click)="cancelEdit(item)"
            >
              <nb-icon icon="close-circle-outline"> </nb-icon>
            </button>

            <input
              type="text"
              nbInput
              fullWidth
              shape="semi-round"
              class="form-control"
              placeholder="Nhập tên"
              [(ngModel)]="title"
            />

            <button
              nbSuffix
              nbButton
              ghost
              status="primary"
              shape="semi-round"
              nbTooltip="{{ 'buttons.save' | translate }}"
              (click)="confirmEdit(item)"
            >
              <nb-icon icon="save-outline"> </nb-icon>
            </button>
          </nb-form-field>
        </div>

        <div *ngIf="!isEditing" class="button-action">
          <button
            nbButton
            ghost
            status="danger"
            size="small"
            [disabled]="submitted"
            [class.btn-pulse]="submitted"
            (click)="delete(item)"
          >
            <nb-icon icon="trash-2-outline"></nb-icon>
          </button>

          <button
            nbButton
            ghost
            status="info"
            size="small"
            [disabled]="submitted"
            [class.btn-pulse]="submitted"
            (click)="onEdit(item)"
          >
            <nb-icon icon="edit-2-outline"></nb-icon>
          </button>
        </div>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
</nb-card>
